import '../../../styles/Recipe.css';
import '../../../styles/Buttons.css';
import '../../../styles/Modals.css';
import '../../../styles/Inputs.css';
import '../../../styles/Containers.css';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';

const TopNavbarCalen = ({title}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // const handleOpenModal = () => {
  //   setShowModal(true);
  // };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    // send the input value to the server
    sendDataToServer(selectedDate);
  };

  const sendDataToServer = (data) => {
    // make a request to the server using fetch or axios
    // Example using fetch:
    fetch("https://example.com/endpoint", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((responseData) => {
        // handle the server response
        console.log(responseData);
      })
      .catch((error) => {
        // handle the error
        console.error(error);
      });
  };

  return (
    <div className="spc-between topnav-container">
      <Link to="#" className="rectangle bTransparent">
        <span className="icon-icondates"></span>
        {/* onClick={handleOpenModal} */}
      </Link>
      {/* <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        contentLabel="Date Picker Modal"
        className="modal"
        overlayClassName="overlay">
        <div className="modal-header">
          <h2>انتخاب تاریخ</h2>
          <Link to="" onClick={handleCloseModal}>
            <span className="icon-iconclose rectangle heading-1"></span>
          </Link>
        </div>
        <div className="modal-body">
          <p>روز خاصی رو میخوای؟</p>
          <p>پیداش کن، انتخابش کن و "تایید" رو فشار بده</p>
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="dd/MM/yyyy"
            className="inputField"
          />
        </div>
        <div className="modal-footer">
          <Link to="" onClick={handleSubmit} className="fill-container radius1-5">
            تایید
          </Link>
        </div>
      </Modal> */}

      <p className="N-txt">{title}</p>

      <Link to="" className="rectangle bTransparent">
        <span className="icon-iconshare"></span>
      </Link>
    </div>
  );
};

export default TopNavbarCalen;
